import React from "react";
import { connect } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from "react-router-dom";
import SearchSuggest from '../shared/search-suggest/SearchSuggest';
import "./ExamDetails.css";
import StepForm from "../state-transition/StateTransition";
import {
  addNewRow,deleteRow,
  examSeriesMonthHandleChange,
  examSeriesYearHandleChange,
  examHandleChange,
  examCenterHandleChange,
  candidateNumberHandleChange,
  updateEmptyFlagExam,
  updateDuplicateFlagExam,
  updateExamDetailsFlag,
  getExamSeries,
  getExamCenters,
  saveExamDetails,
  setShowLoaderStatus,
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails 
} from './../../redux-building-blocks/actions';
import { isEmpty } from "lodash";
import _ from 'lodash';
import { constants } from "../../constants";

export class ExamDetails extends React.Component {

  constructor(props) {
    super(props)
    this.searchHandler = this.searchHandler.bind(this);
    
  }

  reDirectToHistory = () => {
    this.props.resetPersonalInfoData();
    this.props.restExamDetails();
    this.props.restInstitutionDetails();
    this.props.history.push('/transcript-history')
  }

  componentDidMount() {
    if(isEmpty(this.props.examSeriesApiValues)) {
      this.props.getExamSeries();
    }

    if(isEmpty(this.props.examCenterApivalues)) {
      this.props.getExamCenters();
    }
  }

  state = {
    errorMsgs: {
      examSeriesMonth:"Please select the month of the exam(s).",
      examSeriesYear: "Please select the year of the exam(s).",
      examSeriesMonthandYear: "Please select the month and year of the exam(s).",
      exam: "Please select the exam(s).",
      examCenter: "Please enter the exam center name or number.",
      duplicateSeriesMsg: "Kindly check for duplicate entries.",
    },
  };

  handleSubmit = event => {
    for (let i = 0; i < this.props.examDetailsList.length; i++) {
      if (this.props.examDetailsList[i].examSeries.month === "" ||
        this.props.examDetailsList[i].examSeries.year ==="" ||
        this.props.examDetailsList[i].exam === "" ||
        this.props.examDetailsList[i].examCenter === "") {
        this.props.updateEmptyFlagExam("true" ,this.props.examDetailsList[i].id);
      }
      else {
        this.props.updateEmptyFlagExam("false" ,this.props.examDetailsList[i].id);
      }
    }
    setTimeout(() => {
      const emptyFlag = this.props.examDetailsList.some(item => item.emptyValueFlag === "true");
      const duplicateFlag = this.props.examDetailsList.some(item => item.duplicateValueFlag === "true");
      if(emptyFlag === false && duplicateFlag === false){
        this.props.setShowLoaderStatus(true);
        const payload = {
          transactionId: this.props.transactionId,
          transactionStatus: "inProgress",
          qualifications: this.props.examDetailsList
        }; 
        this.props.saveExamDetails(payload, () => {
          this.props.history.push('/institution-details');
        })
        
      }else {
        this.handleValidation(uuidv4());
      }
    },0);

  }

  handleValidation = event => {

    if(this.props.examDetailsList.length > 1){
      var valuesObject={};
      var duplicateArray=[];
      for(let i=0;i<this.props.examDetailsList.length;i++){
        valuesObject.month = this.props.examDetailsList[i].examSeries.month;
        valuesObject.year = this.props.examDetailsList[i].examSeries.year;
        valuesObject.examCenter = (this.props.examDetailsList[i].examCenter !== '' ? this.props.examDetailsList[i].examCenter : 'Empty');
        for(let j=i+1;j<this.props.examDetailsList.length;j++){
          if((valuesObject.month === this.props.examDetailsList[j].examSeries.month) &&
            (valuesObject.year === this.props.examDetailsList[j].examSeries.year) &&
            (valuesObject.examCenter === this.props.examDetailsList[j].examCenter))
            {
            duplicateArray.push(this.props.examDetailsList[j].id);
          }
        }
      }

      if(duplicateArray.length > 0){
        this.props.examDetailsList.forEach(
          (item, i) => {
            if(duplicateArray.includes(item.id)){
              this.props.updateDuplicateFlagExam("true" ,item.id);
            } else{
              this.props.updateDuplicateFlagExam("false" ,item.id);
            }
          }
        )
      } else {
        this.props.examDetailsList.forEach(
          (item, i) => {
            this.props.updateDuplicateFlagExam("false" ,item.id);
          })
      }
    }
  };

  searchHandler(value, index) {
    if(value === null){
      this.props.examCenterHandleChange({
        dataValue: '',
        dataID: ''
      }, index);
      this.props.updateEmptyFlagExam("true" ,index);
      setTimeout(() => {
        this.handleValidation(uuidv4());
      },0);

    }else{
      this.props.examCenterHandleChange(value, index);
      this.props.updateEmptyFlagExam("false" ,index);
      setTimeout(() => {
        this.handleValidation(uuidv4());
      },0);
    }
  }

  examSeriesMonthHandleChange = (value, id) => {
    this.props.examSeriesMonthHandleChange(value,id);
    this.props.examSeriesYearHandleChange("",id);
    setTimeout(() => {
      this.handleValidation(uuidv4());
    },0);
  }

  examSeriesYearHandleChange = (value, id) => {
    this.props.examSeriesYearHandleChange(value,id);
    setTimeout(() => {
      this.handleValidation(uuidv4());
    },0);
  }

  deleteExamRow(id){
    this.props.deleteRow(id);
    setTimeout(() => {
      this.handleValidation(uuidv4());
    },0);
  }

  render() {

    const examSeriesApiValuesList = (this.props.examSeriesApiValues && 
      this.props.examSeriesApiValues.length > 0) ?
    [...this.props.examSeriesApiValues].map(item => item?.session?.split(" ")) : [];

    const examSeriesMonthApiValuesList = (examSeriesApiValuesList && 
      examSeriesApiValuesList.length) ?
    [...new Set(examSeriesApiValuesList.map(item => item[0]))] : [];

    const examSeriesJuneYearApiValuesList1 = (examSeriesApiValuesList && 
      examSeriesApiValuesList.length) ?
      [...new Set(examSeriesApiValuesList.map(item => item[0]?.toLowerCase() === "june" ? item[1] : null))] : [];

    const examSeriesJuneYearApiValuesList = _.compact(examSeriesJuneYearApiValuesList1);
    
    const examSeriesNovemberYearApiValuesList1 = (examSeriesApiValuesList && 
      examSeriesApiValuesList.length) ?
      [...new Set(examSeriesApiValuesList.map(item => item[0]?.toLowerCase() === "november" ? item[1] : null))] : [];

    const examSeriesNovemberYearApiValuesList = _.compact(examSeriesNovemberYearApiValuesList1);

    const examApiValuesList = (this.props.examApiValues && 
      this.props.examApiValues.length) ?
      [...this.props.examApiValues] : [];

    const examCentersApivaluesList = (this.props.examCenterApivalues && 
      this.props.examCenterApivalues.length) ?
    [...this.props.examCenterApivalues] : [];
    
    return (
      <React.Fragment>
        <div className="w-100">
          <StepForm pathname={this.props.location.pathname}></StepForm>
          <label className ="h3Size mb-0.6"><b>Exam details</b><span className="error h3Size">&nbsp;*Required</span></label>
          {this.props.examDetailsList && this.props.examDetailsList.map((value, index) => {
            return (
              <div key={value.id} className={(value.duplicateValueFlag === "true") ? "card border-danger mb-3" : "card mb-3"}>
                <form>
                  <div className="card-body px-0 pt-2">

                    {index!==0 ? <button type="button" className="btn crossButtonExam py-0" id="deleteRow" onClick={() => this.deleteExamRow(value.id)}>&#x2716;</button>:""}

                    <span className="examSeriesLabel">Exam series <span className="errorLabel">*</span></span>

                    <div>
                      <div className="row pl-3">
                        <div className="col-lg-3 col-6 col-sm-4 col-md-3">
                          <div className="select-form-group">
                            <select id="month" data-testid="monthSelector" className={(value.emptyValueFlag === "true" && value.examSeries.month.length < 1) ? "form-control errorMsg" : (value.examSeries.month.length > 1) ? "form-control success" : "form-control"} value={value.examSeries.month} onChange={(e) => this.examSeriesMonthHandleChange(e.target.value, value.id)}>
                              <option value="" disabled  defaultValue>Month</option>
                              {examSeriesMonthApiValuesList.sort().map(function(item) {
                                return <option key={uuidv4()} value={item}>{item}</option>
                              })}
                            </select>
                          </div>
                          {(value.emptyValueFlag === "true" && (value.examSeries.month.length < 1 && value.examSeries.year.length > 1)) && (
                            <small className="examdateError">{this.state.errorMsgs.examSeriesMonth}</small>)}
                        </div>
                        <div className="col-lg-2 col-5 col-sm-3 col-md-2">
                          <div className="select-form-group">
                            <select id="year" data-testid="yearSelector" disabled={value.examSeries.month.length < 1 ? true : false} className={(value.emptyValueFlag === "true" && value.examSeries.year.length < 1) ? "form-control errorMsg" : (value.examSeries.year.length > 1) ? "form-control success" : "form-control" } value={value.examSeries.year} onChange={(e) => this.examSeriesYearHandleChange(e.target.value, value.id)}>
                              <option value="" disabled defaultValue>Year</option>
                              {value.examSeries.month.toLowerCase() === "june" ? 
                                examSeriesJuneYearApiValuesList.map(function(item) {
                                return <option key={uuidv4()} value={item}>{item}</option>
                              }) : 
                                examSeriesNovemberYearApiValuesList.map(function(item) {
                                return <option key={uuidv4()} value={item}>{item}</option>
                              })}
                            </select>
                          </div>
                          {(value.emptyValueFlag === "true" && (value.examSeries.year.length < 1 && value.examSeries.month.length > 1)) && (
                            <small className="examdateError">{this.state.errorMsgs.examSeriesYear}</small>)}
                        </div>
                      </div>
                      {(value.emptyValueFlag === "true" && (value.examSeries.month.length < 1 && value.examSeries.year.length < 1)) && (
                        <small className="examdateError pl-3 ml-2">{this.state.errorMsgs.examSeriesMonthandYear}</small>)}
                      {this.props.examDetailsList.length === (index + 1) &&
                        <small className="form-text text-muted pl-3 ml-2">
                          When did you take the exam(s)?&nbsp;&nbsp;November Series exams are taken in October and November.<br />
                          June Series exams are taken in May and June.
                            </small>}
                    </div>

                    <div className="form-group col-12 col-lg-5 col-sm-6 col-md-5 examMargin">
                      <label className={(value.emptyValueFlag === "true" && value.exam.length < 1) ? "errorLabel": value.exam.length > 1 ? "successLabel" : ""}>Exam<span className="errorLabel">*</span></label>
                      <input type="text" id="exam" list="examList" className={(value.emptyValueFlag === "true" && value.exam.length < 1) ? "form-control errorMsg":"form-control success bg-white"} disabled data-toggle="tooltip" data-placement="right" value="AS & A Level exams and/or AICE Diploma" title="AS & A Level exams and/or AICE Diploma" data-testid="testExam"onChange={(e)=>this.props.examHandleChange(e.target.value,value.id)}></input>
                      <small className="form-text text-muted ml-2">
                        Transcripts will include all passing AS & A Level exam grades from an exam series.
                            </small>
                      <datalist id="examList">
                        {examApiValuesList.map(function(item) {
                          return <option key={item.name} value={item.name}/>})}
                      </datalist>
                      {(value.emptyValueFlag === "true" && value.exam.length < 1) && (
                        <small className="error">{this.state.errorMsgs.exam}</small>)}
                    </div>

                    <div className="form-group col-12 col-lg-5 col-sm-6 col-md-5 d-flex mb-0 ExamCenterMargin">
                      <SearchSuggest dataList={examCentersApivaluesList} searchHandler = {this.searchHandler} index={value.id} minCharToStartSearch={3}
                        label="Exam center" placeholder="Search by number or name" initialValue={value.examCenter} haveError={this.props.examDetailsList[index].emptyValueFlag}
                      />
                    </div>
                    <div className="col-12">
                      {(value.emptyValueFlag === "true" && value.examCenter.length < 1) && (
                        <small className="error">{this.state.errorMsgs.examCenter}</small>)}
                      {this.props.examDetailsList.length === (index + 1) && <small className="form-text text-muted ml-2">
                        This is the school or facility where you took or will take the exam(s).
                        </small>}
                    </div>

                    <div>
                      <div className=" form-group col-9 col-lg-3 col-sm-4 col-md-3 mb-1">
                        <label className="candidateMargin">Candidate number</label>
                        <input type="tel" id="candidateNumber" maxLength={4} className="form-control" value={value.candidateNumber} data-toggle="tooltip" data-placement="right" title={value.candidateNumber} data-testid="testCandidateNumber" onChange={(e)=>this.props.candidateNumberHandleChange(e.target.value,value.id)}></input>
                      </div>
                      <small  className="form-text text-muted pl-3 mt-0 ml-2">
                        This four-digit number is available from your school or on your statement of results or certificate.
                    </small>
                    </div>
                    {this.props.examDetailsList[index].duplicateValueFlag === "true"&& (
                      <div className="mb-2">
                        <small className="form-text padLeftExam errorLabelInstitute">
                          Please remove the duplicate listing of an exam series.
                        </small>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            );
          })}

        {this.props.examDetailsList && this.props.examDetailsList.length < 6 && <span className="addNewSeries" id="addNewExamSeries" onClick={this.props.addNewRow}>
        <b>+Add another series</b></span>}
        <div className="mt-3 mb-3">{constants.EXAM_DETAILS.HELP_TEXT}</div>         
        <div className="mt-3 mb-3">
            <button type="button" className="btn font-weight-bold save-button-exam text-white mb-0 mt-2 mr-3" id="saveButton" onClick={(event) => this.handleSubmit(event)}>
              Save and continue
            </button>            
            <button onClick={this.reDirectToHistory} type="button" className="btn btn-link font-weight-bold mt-2 text-decoration-none"><span>Cancel</span></button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    examDetailsInfoFlag : state.stateTransition.isExamDetailsCrossed,
    examDetailsList : state.examDetailsInfo.examDetailsList,
    examSeriesApiValues : state.examDetailsInfo.examSeriesApiValues,
    examCenterApivalues : state.examDetailsInfo.examCenterApivalues,
    examApiValues : state.examDetailsInfo.examApiValues,
    transactionId: state.commonData.transactionId
  };
};

const mapDispachToProps =  {
  addNewRow,
  deleteRow,
  examSeriesMonthHandleChange,
  examSeriesYearHandleChange,
  examHandleChange,
  examCenterHandleChange,
  candidateNumberHandleChange,
  updateDuplicateFlagExam,
  updateEmptyFlagExam,
  updateExamDetailsFlag,
  getExamSeries,
  getExamCenters,
  saveExamDetails,
  setShowLoaderStatus,
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails 
};
export default withRouter(connect(
  mapStateToProps,mapDispachToProps
)(ExamDetails));